export default __webpack_public_path__ + "static/media/Prev.c4ee25e7.svg";